  $(document).ready(function() {
      // This code added by sharif Nawaz
      $(".multiple-section.text-section-open").click(function(){
         $('.btn-group .chest-btn').eq(1).click();
      })
      // End
    
      // popup js
      $('#embroidery-openPopup').click(function() {
          $('#popup-embroidery').fadeIn();
          $('.popup-content-embroidery').addClass('show');
      });
      $('.close-embroidery').click(function() {
          $('.popup-content-embroidery').removeClass('show');
          $('#popup-embroidery').fadeOut();
      });
      $(window).click(function(event) {
          if ($(event.target).is('#popup-embroidery')) {
              $('.popup-content-embroidery').removeClass('show');
              $('#popup-embroidery').fadeOut();
          }
      });

    
      // popup functionality js
      $('.text-section-open').on('click',function(){
          $('.embroidery-section,.left-image-section').hide();
          $('.add-text-card,.add-icon-text-image').show();
      })
      $('.add-text-back').on('click',function(){
          $('.embroidery-section,.left-image-section').show();
          $('.add-text-card,.add-icon-text-image').hide();
          if($('#add-text-added').hasClass('added')) { 
              $('#add-text-card').prop('checked',true);
              $('.selected-text-section').show()
              selctedTextStyling()
          }else{
              $('.selected-text-section').hide()
              $('#first-line').val('')
              $('#second-line').val('')
              $('.print-text-first span').html('')
              $('.print-text-second span').html('')
              $('.btn-group .chest-btn').first().click();
              $('.text-clr-btn').first().click();
              $('.chest-font-btn').first().click();
              $('#add-text-card').prop('checked',false);
         }
        
      })
       
      $('#add-text-reset').on('click',function(){
          $('.selected-text-section').hide()
          $('#first-line').val('')
          $('#second-line').val('')
          $('.print-text-first span').html('')
          $('.print-text-second span').html('')
          //$('.btn-group .chest-btn').first().click();
          $('.btn-group .chest-btn').eq(1).click();
          $('.text-clr-btn').first().click();
          $('.chest-font-btn').first().click();
          $('#add-text-added').removeClass('added')
          $('#add-text-card').prop('checked',false);
          if ($('#add-text-card').is(':checked') || $('#add-icon-card').is(':checked')) {
              $('#icon-and-text-confirm').removeAttr('disabled');
          } else {
              $('#icon-and-text-confirm').attr('disabled', 'disabled');
          }
          $('#embroidery-div-myName').remove()
      })

      $('#add-text-added').on('click',function(){
          if($('#first-line').val().length > 0 ){
             $(this).addClass('added');
             $('.embroidery-section,.left-image-section').show();
             $('.add-text-card,.add-icon-text-image').hide();
             if ($(this).hasClass('added')) { 
                $('#add-text-card').prop('checked',true);
                $('.selected-text-section').show()
                selctedTextStyling();
                $('#icon-and-text-confirm').removeAttr('disabled')
             }
             $('#first-line-error').hide()
          }else{
             $('#first-line-error').show()
             $('#first-line-error').html('First line is required')
          }
      })
    
      $('#first-line, #second-line').on('keyup', function() {
          var currentValue = $(this).val();
          var inputLength = currentValue.length;
          var maxLength = $(this).attr('maxlength');
          if (this.id === 'first-line') {
             $('.print-text-first span').text($(this).val());
             $(this).siblings('span').text(inputLength + '/' + maxLength);
          } else if (this.id === 'second-line') {
             $('.print-text-second span').text($(this).val());
             $(this).siblings('span').text(inputLength + '/' + maxLength);
          }
      })
    
      $('.chest-btn').on('click', function() {
          $('.chest-btn').removeClass('active');
          $(this).addClass('active');
          var direction = $(this).data('direction');
          if (direction === 'right') {
             $('.print-text-first,.print-text-second').removeClass('right');
             $('.print-text-first,.print-text-second').addClass('left');
          } else if (direction === 'left') {
             $('.print-text-first,.print-text-second').removeClass('left');
             $('.print-text-first,.print-text-second').addClass('right');
          }
      });
      $('.text-clr-btn').on('click', function() {
          $('.text-clr-btn').removeClass('active');
          $(this).addClass('active');
          var direction = $(this).data('direction');
          if (direction === 'white') {
            $('.print-text-second, .print-text-first span').css('color', '#fff');
          } else if (direction === 'black') {
             $('.print-text-second, .print-text-first span').css('color', '#000000');
          }
      });
    
      $('.chest-font-btn').on('click', function() { 
          $('.chest-font-btn').removeClass('active');
          $(this).addClass('active');
          var style = $(this).data('style');
          if (style === 'normal') {
             $('.print-text-second, .print-text-first span').css('font-family', '');
          } else if (style === 'italic') {
             $('.print-text-second, .print-text-first span').css('font-family', 'VarsityScriptJF');
            
          }
      });
      function selctedTextStyling(){
        $('.selected-text-first').text($('#first-line').val())
        $('.selected-text-second').text($('#second-line').val())

        if ($('.chest-btn.active').data('direction') == "left") {
            $('.selected-text-section').removeClass('right');
            $('.selected-text-section').addClass('left');
        }else{
            $('.selected-text-section').removeClass('left');
            $('.selected-text-section').addClass('right');
        } 


        
        if ($('.text-clr-btn.active').data('direction') == "black") { 
            $('.selected-text-first,.selected-text-second').css('color','#000000');
        }else{
            $('.selected-text-first,.selected-text-second').css('color','#fff');
        }
        if ($('.chest-font-btn.active').data('style') == "italic") { 
            $('.selected-text-first,.selected-text-second').css('font-family','VarsityScriptJF');
        }else{
            $('.selected-text-first,.selected-text-second').css('font-family','');
        }
        
      }
    

    // ----
      $('.icon-section-open').on('click',function(){
          $('.embroidery-section,.left-image-section').hide();
          $('.add-icon-card,.add-icon-text-image').show();
      })
    
      $('.add-icon-back').on('click',function(){
          $('.embroidery-section,.left-image-section').show();
          $('.add-icon-card,.add-icon-card,.add-icon-text-image').hide();
          if($('.add-icon-logo.active').length > 0 ){
             $('.selected-icon-section').show()
             $('#icon-line-error').hide()
             $('#add-icon-card').prop('checked',true);
             selctedIconStyling();
          }else{
             $('.selected-icon-section').hide()
             $('.add-icon-logo').removeClass('active');
             $('#icon-text-input').val('')
             $('#text-black-icn').click();
             $('.inner-images img').attr('src','')
             $('#icon-2-text').html('')
             $('#add-icon-card').prop('checked',false);
          }
      }) 

    
      $('.add-icon-logo').on('click', function() {
          $('.add-icon-logo').removeClass('active');
          $(this).addClass('active');
          var imgSrc = $(this).find('img').attr('srcset');
          var alt = $(this).find('img').attr('alt');
          $('.inner-images img').attr('src',imgSrc)
          $('.inner-images img').attr('alt',alt)
      });

    
      $('#icon-text-input').on('keyup', function() {
          var currentValue = $(this).val();
          var inputLength = currentValue.length;
          var maxLength = $(this).attr('maxlength');
          $('#icon-2-text').text($(this).val());
          $(this).siblings('span').text(inputLength + '/' + maxLength);
      })

      $('.icon-clr-btn').on('click', function() {
          $('.icon-clr-btn ').removeClass('active');
          $(this).addClass('active');
          var direction = $(this).data('direction');
          if (direction === 'white') {
             $('#icon-2-text').css('color','#fff')
          } else if (direction === 'black') {
             $('#icon-2-text').css('color','#000000')
          }
      });

      $('#add-icon-reset').on('click', function() {
          $('.selected-icon-section').hide()
          $('.add-icon-logo').removeClass('active');
          $('#icon-text-input').val('')
          $('#text-black-icn').click();
          $('.inner-images img').attr('src','')
          $('#icon-2-text').html('')
          $('#add-icon-card').prop('checked',false);
          if ($('#add-text-card').is(':checked') || $('#add-icon-card').is(':checked')) {
              $('#icon-and-text-confirm').removeAttr('disabled');
          } else {
              $('#icon-and-text-confirm').attr('disabled', 'disabled');
          }
          $('#embroidery-div-myIcon').remove()
      }); 

      $('#add-icon-added').on('click',function(){
          if($('.add-icon-logo.active').length  > 0 ){
             $(this).addClass('added');
             $('.embroidery-section,.left-image-section').show();
             $('.add-text-card,.add-icon-card,.add-icon-text-image').hide();
             if ($(this).hasClass('added')) { 
                $('#add-icon-card').prop('checked',true);
                $('.selected-icon-section').show()
                selctedIconStyling();
                $('#icon-and-text-confirm').removeAttr('disabled')
             }
             $('#icon-line-error').hide()
          }else{
            $('#icon-line-error').show()
            $('#icon-line-error').html('Icon is required')
          }
      })

      function selctedIconStyling(){
         $('.selected-icon-section img').attr('src',$('.add-icon-logo.active img').attr('srcset'))  
         $('.selected-icon-section img').attr('alt',$('.add-icon-logo.active img').attr('alt'))  
         $('.selected-icon-text').text($('#icon-text-input').val())
         if ($('.icon-clr-btn.active').data('direction') == "black") { 
            $('.selected-icon-text').css('color','#000000');
         }else{
            $('.selected-icon-text').css('color','#fff');
         }
      }

      //-------
      $('#icon-and-text-reset').on('click',function(){
         $('#add-text-reset').click()
         $('#add-icon-reset').click()
         $('#embroidery-div-myIcon').remove()
         $('#embroidery-div-myName').remove()
         $('#product-page-final-sale').hide()
      })

    
      $('#icon-and-text-confirm').on('click',function(){
         if($('#add-text-card').is(':checked')) {
             $('#embroidery-div-myName').remove();
             $('product-form').prepend('<div id="embroidery-div-myName"></div>');
             var first_line = $('#first-line').val();
             var second_line = $('#second-line').val();
             $('#embroidery-div-myName').append(`
               <input type="hidden" name="properties[First-line]" value="${first_line}" />
               <input type="hidden" name="properties[Second-line]" value="${second_line}" />
             `)

             if ($('.chest-btn.active').data('direction') == "left") { 
                $('#embroidery-div-myName').append(`<input type="hidden" name="properties[Text-placement]" value="Left Chest" />`)
             }else{
                $('#embroidery-div-myName').append(`<input type="hidden" name="properties[Text-placement]" value="Right Chest" />`)
             }
             if ($('.text-clr-btn.active').data('direction') == "black") { 
                $('#embroidery-div-myName').append(`<input type="hidden" name="properties[Text-color]" value="Black" />`)
             }else{
                $('#embroidery-div-myName').append(`<input type="hidden" name="properties[Text-color]" value="White" />`)
             }
             if ($('.chest-font-btn.active').data('style') == "italic") { 
                $('#embroidery-div-myName').append(`<input type="hidden" name="properties[Text-font]" value="Script" />`)
             }else{
                $('#embroidery-div-myName').append(`<input type="hidden" name="properties[Text-font]" value="Block" />`)
             }
         } 
        
         if ($('#add-icon-card').is(':checked')) {
             $('#embroidery-div-myIcon').remove();
             $('product-form').prepend('<div id="embroidery-div-myIcon"></div>');
             $('#embroidery-div-myIcon').append(`<input type="hidden" name="properties[Icon-placement]" value="Left Sleeve" />`)
             $('#embroidery-div-myIcon').append(`<input type="hidden" name="properties[Icon-initials]" value="${$('#icon-text-input').val()}" />`)
             if ($('.icon-clr-btn.active').data('direction') == "black") { 
                $('#embroidery-div-myIcon').append(`<input type="hidden" name="properties[Icon-initials-color]" value="black" />`)
             }else{
                $('#embroidery-div-myIcon').append(`<input type="hidden" name="properties[Icon-initials-color]" value="White" />`)
             }
             $('#embroidery-div-myIcon').append(`<input type="hidden" name="properties[Icon-image]" value="${$('.selected-icon-section img').attr('alt')}" />`)
         } 
         $('.close-embroidery').click()

         if ($('#add-text-card').is(':checked') || $('#add-icon-card').is(':checked')) {
        	  $('.details-section').hide() 
        	  $('.embroidery-settings-section').show()   
        	  if ($('#add-text-card').is(':checked')){
        		  $('.text-add-settings-section').show()
                  $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:first-child').text($('#first-line').val());
                  $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:last-child').text($('#second-line').val());
        		  $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(1)').text("First Line: "+$('#first-line').val());
        		  $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(2)').text("Second Line: "+$('#second-line').val());
                  if ($('.chest-font-btn.active').data('style') == "italic") { 
        		      $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(3)').text("Select Font Type: Script");
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:first-child').css('font-family','VarsityScriptJF')
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:last-child').css('font-family','VarsityScriptJF')
                  }else{
                      $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(3)').text("Select Font Type: Block");
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:first-child').css('font-family','')
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:last-child').css('font-family','')
                  }
        		  if ($('.text-clr-btn.active').data('direction') == "black") { 
        		      $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(4)').text('Text Color: black');
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:first-child').css('color','#000000')
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:last-child').css('color','#000000')
                  }else{
                      $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(4)').text('Text Color: White');
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:first-child').css('color','#fff')
                      $('.EmbroiderySneakPeek__TextEmbroideryVisual-sc-5l5hs6-2 span:last-child').css('color','#fff')
                  }	
                  if ($('.chest-btn.active').data('direction') == "left") { 
                      $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(5)').text('Text Placement: Left Chest');
                  }else{
                      $('.EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(5)').text('Text Placement: Right Chest');
                  }     
        	  }else{
        		  $('.text-add-settings-section').hide()
        	  }
           
        	  if ($('#add-icon-card').is(':checked')){
        		  $('.icon-add-settings-section').show()
        		  $('.EmbroiderySneakPeek__IconEmbroideryVisual-sc-5l5hs6-3 img').attr('src',$('#selected-add-icon').attr('src'))   
                  $('.icon-add-settings-section .EmbroiderySneakPeek__Details-sc-5l5hs6-6 span:eq(1)').text('Icon: '+ $('.add-icon-logo.active img').attr('alt'));
        	  }else{
        		  $('.icon-add-settings-section').hide()
        	  }
              $('#product-page-final-sale').show()
         } else {
        	  $('.details-section').show() 
         	  $('.embroidery-settings-section').hide()    
              $('#product-page-final-sale').hide()
         }
         if ($('#add-text-card').is(':checked') && $('#add-icon-card').is(':checked')) {
            var price = $('#popup-embroidery').data('price')
            $('.embroidery-settings-section span.money').text(price)
         }else{
            if ($('#add-text-card').is(':checked')) {
               var price = $('#add-text-card').data('price')
               $('.embroidery-settings-section span.money').text(price)
            }
            if ($('#add-icon-card').is(':checked')) {
               var price = $('#add-icon-card').data('price')
               $('.embroidery-settings-section span.money').text(price)
            } 
         }
      })
      $('.EmbroiderySummary__TrashButton-sc-16kwvyj-7').on('click',function(){
          $('.details-section').show() 
          $('.embroidery-settings-section').hide()     
          $('#icon-and-text-reset').click()
      })
      $('.EmbroiderySummary__EditButton-sc-16kwvyj-6').on('click',function(){
          $('#popup-embroidery').fadeIn();
          $('.popup-content-embroidery').addClass('show');
      })
    
      $(document).on('click', 'td.cart-item__quantity', function() {
        var qty =$(this).find('.quantity__input').val();
        var lineItemId = $(this).find('.quantity__input').data('quantity-variant-id');  
        var data = { updates: {} };
        data.updates[lineItemId] = qty;
        jQuery.ajax({
           type: 'POST',
           url: '/cart/update.js',
           data: data,
           dataType: 'json',
           success: function(data) { 
             updateCart()
          }
        }) 
      })


     

    
      $('.embroidery-add-to-cart').on('click',function(){
          var customProperties = {};
          $(this).addClass('loading')
          $(this).find('.loading__spinner').removeClass('hidden')
          var vid = $('product-form form input[name=id]').val()
          var qty = 1;
          var drawer = false;
          addToCart(vid, qty, customProperties,drawer)
          setTimeout(()=>{
             addEmbroideryProduct()
          },800)
      })
      function addEmbroideryProduct(){
          var customProperties = {};
          if ($('#embroidery-div-myIcon').length) {
              $('#embroidery-div-myIcon input[type="hidden"]').each(function(index, value) {
                 var name = $(value).attr('name').replace('properties[', '').replace(']', '');  
                 var value = $(value).val();  
                 customProperties[name] = value;
              });
          }
          if ($('#embroidery-div-myName').length) {
              $('#embroidery-div-myName input[type="hidden"]').each(function(index, value) {
                 var name = $(value).attr('name').replace('properties[', '').replace(']', '');  
                 var value = $(value).val();  
                 customProperties[name] = value;
              });
          }
          if ($('#embroidery-div-myIcon').length || $('#embroidery-div-myName').length) {
              if ($('#add-text-card').is(':checked') && $('#add-icon-card').is(':checked')) {
                 var vid = $('#popup-embroidery').data('vid')
              }else{
                 if ($('#add-text-card').is(':checked')) {
                   var vid = $('#add-text-card').val();
                 }
                 if ($('#add-icon-card').is(':checked')) {
                   var vid = $('#add-icon-card').val();
                 } 
              }
              var drawer = true;
              addToCart(vid, 1, customProperties, drawer)
          }else{
              updateCart()
          }
      }
      function addToCart(vid, qty, customProperties, drawer){
         $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                id: vid, 
                quantity: qty, 
                properties: customProperties
            },
            success: function(data) {
                console.log('Product added to cart:', data);
                 $('.embroidery-add-to-cart').removeClass('loading')
                 $('.embroidery-add-to-cart').find('.loading__spinner').removeClass('hidden')
                 if(drawer){
                    updateCart();
                 }

            },
            error: function(error) {
                 $('.embroidery-add-to-cart').removeClass('loading')
                 $('.embroidery-add-to-cart').find('.loading__spinner').removeClass('hidden')
            }
         });
      }
  });